import React from "react";
import { useTranslation } from "react-i18next";
import { PageSelectionButton } from "../PageSelectionButton/PageSelectionButton";
import { Squash as Hamburger } from "hamburger-react";
import { DemoTrialModalButton } from "../ModalButtons/DemoTrialModalButton";
import { RetailersButton } from "../RetailersButton/RetailersButton";
import { AnchorLink } from "../AnchorLink/AnchorLink";
import { getImage } from "../../services/ImageService";

export function PageSelection() {
    const { t } = useTranslation();

    const [isOpen, setOpen] = React.useState(false);

    const toggleMenu = () => {
        setOpen((current) => !current);
        const scrollStyle = isOpen ? "auto" : "hidden";
        document.body.style.overflow = scrollStyle;
    };

    const openSiteSearch = () => {
        toggleMenu();
        window.dispatchEvent(new Event("open-site-search"));
    };

    return (
        <div className="w-full h-full flex items-center 2xl:hidden">
            <div className="w-full h-full text-pine z-20 flex items-center justify-start">
                <Hamburger
                    color="#242D29"
                    rounded
                    size={24}
                    toggled={isOpen}
                    toggle={toggleMenu}
                />
            </div>
            <div
                className={`absolute top-32 bg-white z-10 w-max transition-all ease-in-out select-none overflow-y-auto max-h-[calc(96vh-6rem)] max-w-[calc(90vw-2rem)] rounded-br-xl rounded-bl-xl shadow-2xl ${
                    isOpen
                        ? "opacity-1 translate-y-[0]"
                        : "opacity-0 -translate-y-full"
                }`}
            >
                <button
                    onClick={openSiteSearch}
                    className="w-full flex items-center justify-between gap-2 px-12 py-6 text-pine font-bold text-base hover:bg-pine hover:text-white transition-colors"
                >
                    {t("search-placeholder")}
                    <img
                        className="pointer-events-none w-6 h-6 opacity-30"
                        src={getImage("gui/search-pine.svg")}
                        alt=""
                        draggable={false}
                    />
                </button>
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("home")}
                    target=""
                />
                <div className="mx-12 opacity-30 font-bold text-sm pt-8 pb-4">
                    {t("solutions")}
                </div>
                <AnchorLink
                    onClick={toggleMenu}
                    content={t("timber-purchases")}
                    target="/#timber-purchases"
                />
                <AnchorLink
                    onClick={toggleMenu}
                    content={t("forest-management")}
                    target="/#forest-management"
                />
                <AnchorLink
                    onClick={toggleMenu}
                    content={t("damage-inventory")}
                    target="/#damage-inventory"
                />
                <AnchorLink
                    onClick={toggleMenu}
                    content={t("forest-owner-relations")}
                    target="/#forest-owner-relations"
                />
                <AnchorLink
                    onClick={toggleMenu}
                    content={t("home-wildlife-card-title")}
                    target="/#wildlife"
                />
                <div className="mx-12 opacity-30 font-bold text-sm pt-8 pb-4">
                    {t("resources")}
                </div>
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("guides")}
                    target="guides"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("manual")}
                    target="manual/introduction"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("api")}
                    target="api"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("faq")}
                    target="faq"
                />
                <div className="my-2 w-full flex gap-6 py-6 px-6 flex-col md:flex-row">
                    <DemoTrialModalButton className="w-full" />
                    <RetailersButton
                        className="w-full"
                        onClick={toggleMenu}
                    />
                </div>
            </div>
        </div>
    );
}
